/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import FormController from "../../../FormController/FormController";
import { getGamesByTimeOfDay } from "../../../../features/cms/cmsSlice";
import FormTitle from "../../../FormTitle/FormTitle";
import CustomTabs from "../../components/CustomTabs/idnex";
import { GameItemList } from "../../components/GameItemList/GameItemList";

const ByTimeOfDay = () => {
  const history = useHistory();
  const { type } = useSelector((state) => state?.singleGroup);
  const games = useSelector(getGamesByTimeOfDay);

  const [tabs, setTabs] = useState();
  const timelabels = {
    weekendDay: "Weekend Day Games",
    weekendEve: "Weekend Evening Games",
    weekdayDay: "weekday Day Games",
    weekdayEve: "weekday Evening Games",
  };

  useEffect(() => {
    if (!type) history.push("/");

    if (!tabs) {
      const _tabs = Object.keys(games).map((d) => {
        return {
          id: d,
          label: timelabels[d],
          comp: <GameItemList games={games[d]} />,
        };
      });

      setTabs(_tabs);
    }
  }, [games, history, tabs, timelabels, type]);

  return (
    <div>
      <FormTitle title="by Time Of Day" />
      <div>
        {tabs && (
          <CustomTabs
            tabs={tabs}
            activeTab={history.location.state?.data}
            trackingTitle="Games By Time Of Day"
          />
        )}
      </div>
      <FormController
        backTo="/ticket-single-group/by-time-of-day-landing"
        startOver="/"
        showBack
        showStartOver
      />
    </div>
  );
};

export default ByTimeOfDay;
